import React from "react"

import Post from "./post"

const RelatedPosts = ({ posts }) => {
  return (
    <section className="c-bottomSection">
      <h2 className="c-bottomSection__title">関連記事 </h2>
      <ul className="p-postList -type-list -related">
        {posts.map(post => (
          <Post post={post} key={post.id} heading={0} excerpt meta />
        ))}
      </ul>
    </section>
  )
}

export default RelatedPosts
